/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-empty-function */
/* eslint-disable   @typescript-eslint/no-unused-expressions */

import { Component, DestroyRef, inject, input, OnDestroy, OnInit } from '@angular/core';
import { debounceTime, Subscription } from 'rxjs';
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatIconButton } from '@angular/material/button';
import { MatInput, MatSuffix } from '@angular/material/input';
import {  TrackData } from '@shared/interfacres/track';
import { MatIcon } from '@angular/material/icon';
import { provideNativeDateAdapter } from '@angular/material/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Genre } from '@shared/interfacres/genre';

interface TracksForm {
  title: FormControl<string | null>;
  artists: FormControl<string | null>;
  genre: FormControl<Genre | null>;
  subgenre: FormControl<Genre | null>;
  bpm: FormControl<number | null>;
  releaseDate: FormControl<Date | null>;
  fileName: FormControl<Date | null>;
}


@Component({
  selector: 'app-edit-track-component',
  imports: [
    ReactiveFormsModule,

    MatAutocomplete,
    MatAutocompleteTrigger,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatIcon,
    MatIconButton,
    MatInput,
    MatOption,
    MatSuffix
  ],
  templateUrl: './edit-track-component.html',
  styleUrl: './edit-track-component.scss',
  providers: [
    provideNativeDateAdapter(),
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: EditTrackComponent,
    }
  ],
})
export class EditTrackComponent implements OnInit, OnDestroy, ControlValueAccessor {
  genresList = input<Genre[]>([]);
  // artistsList = input<Artist[]>([]);
  subgenresList = input<Genre[]>([]);
  track = input<TrackData>();

  onTouched: () => void = () => {};
  onChange: (value: any) => void = () => {};
  subscriptions: Subscription;

  constructor() {
    this.subscriptions = new Subscription();
  }

  private destroyRef = inject(DestroyRef);

  trackForm = new FormGroup({
    title: new FormControl(''),
    artists: new FormControl<string>(''),
    genre: new FormControl<Genre | null>(null),
    subgenre: new FormControl<Genre | null>(null),
    bpm: new FormControl<number>(0),
    releaseDate: new FormControl<Date | null>(null),
    fileName: new FormControl(''),
  });

  genreOptions: Genre[] | undefined;
  subgenreOptions: Genre[] | undefined;

  ngOnInit() {
    this.trackForm.patchValue({
      title: this.track()?.title || null,
      artists: this.track()?.artists,
      genre: this.track()?.genre,
      bpm: this.track()?.bpm || 120,
      subgenre: this.track()?.subgenre || null,
      releaseDate: this.track()?.releaseDate,
      fileName: this.track()?.fileName,
    })

    // this.artistOptions = this.artistsList();
    this.genreOptions = this.genresList();
    this.subgenreOptions = this.subgenresList();

    this.trackForm.controls['genre'].valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(300)
      )
      .subscribe((value) => {
        const name = typeof value === 'string' ? value : value?.name;
        this.genreOptions = name ?
          this.genresList().filter((option: Genre) =>
            option.name.toLowerCase().includes(name.toLowerCase())) :
          this.genresList();
      });

    // this.trackForm.controls['currentArtist'].valueChanges
    //   .pipe(
    //     takeUntilDestroyed(this.destroyRef),
    //     debounceTime(300)
    //   )
    //   .subscribe((value) => {
    //     const name = typeof value === 'string' ? value : value?.name;
    //     const alreadySelected = this.trackForm.controls.artists.value || [];
    //
    //     this.artistOptions = name ?
    //       this.artistsList().filter((option: Artist) =>
    //         option.name.toLowerCase().includes(name.toLowerCase()) && alreadySelected.findIndex((selected: Artist) => selected.id === option.id) === -1) :
    //       this.artistsList().filter((option: Artist) => {
    //         return alreadySelected.findIndex((selected: Artist) => selected.id === option.id) === -1;
    //       });
    //   });

    this.trackForm.controls['subgenre'].valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(300)
      )
      .subscribe((value) => {
        const name = typeof value === 'string' ? value : value?.name;
        this.subgenreOptions = name ?
          this.subgenresList().filter((option: Genre) =>
            option.name.toLowerCase().includes(name.toLowerCase())) :
          this.subgenresList();
      })
  }


  // remove(artistToRemove: Artist): void {
  //   const updatedArtists = this.trackForm.value.artists?.filter((item: Artist) => {
  //     return item.id !== artistToRemove.id;
  //   });
  //   this.trackForm.controls.artists.setValue(updatedArtists as Artist[]);
  //   this.recalculateAvailable();
  // }

  // recalculateAvailable() {
  //   const alreadySelected = this.trackForm.controls.artists.value || [];
  //   this.artistOptions =
  //     this.artistsList().filter((option: Artist) => {
  //       return alreadySelected.findIndex((selected: Artist) => selected.id === option.id) === -1;
  //   })
  // }

  // selected(event: MatAutocompleteSelectedEvent): void {
  //   this.trackForm.controls.artists.setValue(this.trackForm.controls.artists.value?.concat(event.option.value) as Artist[]);
  //   this.trackForm.controls.currentArtist.setValue({id: 0, name: ''});
  //   event.option.deselect();
  //   this.recalculateAvailable();
  // }


  changeBpm(ev: string) {
    this.trackForm.controls.bpm.setValue(+ev);
  }
  //
  // async copyToClipboard() {
  //   await navigator.clipboard.writeText(this.track()!.url);
  //   this._snackBar.open('Copied to Clipboard', '', {duration: 2000});
  // }

  clearField(fieldName: keyof TracksForm) {

    this.trackForm.controls[fieldName].setValue(null);
  }

  displayFn(item: {id: number; name: string}): string {
    return item?.name || '';
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  writeValue(value: any): void {
    value && this.trackForm.patchValue(value, { emitEvent: false });
  }

  registerOnChange(onChange: (value: any) => void): void {
    this.subscriptions.add(this.trackForm.valueChanges.subscribe(onChange));
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    disabled ? this.trackForm.disable() : this.trackForm.enable();
  }
}
